module.exports = __webpack_public_path__ + "static/img/lx_yellow.44edd784.svg";